export type SurfacesFps = Record<string, { id: string; options: Record<string, string>; version: number }>;

export const surfacesFps: SurfacesFps = {
    // Gable Box
    'https://surface.products.cimpress.io/v3/calculatedSurfaceSets?surfaceSetLink=https%3a%2f%2fsurface.products.cimpress.io%2fv4%2fsurfaceSets%2fbd647318-68c4-4979-9e3b-f8186c5e7f30%2fversions%2f57&Die-Cut=d1_l185xp185xa185&Spot%20Color%20Count%20Side%201=0&Special%20Finishing%20Type%20Side%201=None&Trim%20Width=76.49&Trim%20Height=37.92&Surface%20Bleed=0&Prepress%20Parameters%20URL=https%3a%2f%2fcimdoc-layouts.documents.cimpress.io%2fv1%2ftemplate%2fd7fe752c-5082-456e-9a13-8e4b7844bc9e~100%2fresolved&Prepress%20URL=https%3a%2f%2fprint.prepress.cimpress.io%2fv2%2fprint-prep%3fasynchronous%3dtrue&Printing%20Layout=Front+side+only+printing&_variantId=36c12c2f4fe62bdaac7f5516edd2428f63634a14':
        {
            id: 'CIM-HBGEVEJ7',
            options: {
                AssembledDepth: '18.5',
                AssembledHeight: '18.5',
                AssembledWidth: '18.5',
                'Box Depth': '18.5 cm',
                'Box Width': '18.5 cm',
                Coating: 'None',
                DesignExperience: 'true',
                'Die-Cut': 'd1_l185xp185xa185',
                'Die-Cut Type': 'd1_l185xp185xa185',
                Grammage: '380 gsm',
                'Internal Cut': 'No',
                Lamination: 'Gloss outer only',
                'Nick Position': 'Bottom',
                'Paper Type': 'SBS Paperboard',
                'Printing Layout': 'Front side only printing',
                'Printing White': 'None',
                'Production Time': '120',
                Substrate: 'Technodesign 380gsm',
                'Sustainability Label': 'C/PAP 81',
                Tipology: 'Gable Box',
            },
            version: 12,
        },
    // Auto-Lock Bottom Box (10x10x17cm)
    'https://surface.products.cimpress.io/v3/calculatedSurfaceSets?surfaceSetLink=https%3a%2f%2fsurface.products.cimpress.io%2fv4%2fsurfaceSets%2f6c688893-8061-4bb5-ac20-6bb6259d7f1c%2fversions%2f193&Die-Cut=ap_ds_l100xp100xa170&Spot%20Color%20Count%20Side%201=0&Special%20Finishing%20Type%20Side%201=None&Printing%20Layout=Front+side+only+printing&Prepress%20URL=https%3a%2f%2fprint.prepress.cimpress.io%2fv2%2fprint-prep%3fasynchronous%3dtrue&Prepress%20Parameters%20URL=https%3a%2f%2fcimdoc-layouts.documents.cimpress.io%2fv1%2ftemplate%2f2ff25a76-3c55-4d57-8a2e-94b2f4dea4fd~110%2fresolved&_variantId=17a6dcc0bddf2f53e78fb7573e64a07c7d8c4239':
        {
            id: 'CIM-011PXXXQ',
            options: {
                AssembledDepth: '10',
                AssembledHeight: '17',
                AssembledWidth: '10',
                'Box Depth': '10 cm',
                'Box Width': '10 cm',
                Coating: 'None',
                DesignExperience: 'true',
                'Die-Cut': 'ap_ds_l100xp100xa170',
                'Die-Cut type': 'ap_ds_l100xp100xa170',
                'Feature-Window': 'None',
                Grammage: '380 gsm',
                'Internal Cut': 'No',
                Lamination: 'Matte outer only',
                'Paper Type': 'SBS Paperboard',
                'Printing Layout': 'Front side only printing',
                'Printing White': 'None',
                'Production Time': '120',
                Substrate: 'Technodesign 380gsm',
                'Sustainability Label': 'C/PAP 81',
            },
            version: 26,
        },
    // Auto-Lock Bottom Box with Cold Foil (5x5x5cm)
    'https://surface.products.cimpress.io/v3/calculatedSurfaceSets?surfaceSetLink=https%3a%2f%2fsurface.products.cimpress.io%2fv4%2fsurfaceSets%2faee7710e-e969-4206-b2fa-a5374e80cd03%2fversions%2f246&Die-Cut=at_ds_l50xp50xa50&Spot%20Color%20Count%20Side%201=0&Special%20Finishing%20Type%20Side%201=Cold+Foil&Trim%20Width=21.82&Trim%20Height=19.45&Surface%20Bleed=0&Prepress%20Parameters%20URL=https%3a%2f%2fcimdoc-layouts.documents.cimpress.io%2fv1%2ftemplate%2fd7fe752c-5082-456e-9a13-8e4b7844bc9e~100%2fresolved&Prepress%20URL=https%3a%2f%2fprint.prepress.cimpress.io%2fv2%2fprint-prep%3fasynchronous%3dtrue&Printing%20Layout=Front+side+only+printing&_variantId=1f88543d76a8406535f8a688a325ec5d8ca6a97e':
        {
            id: 'CIM-QRHN2VXG',
            options: {
                AssembledDepth: '5',
                AssembledHeight: '5',
                AssembledWidth: '5',
                'Box Depth': '5 cm',
                'Box Width': '5 cm',
                Coating: 'Silver coating',
                DesignExperience: 'false',
                'Die-Cut': 'at_ds_l50xp50xa50',
                'Die-Cut Type': 'at_ds_l50xp50xa50',
                Grammage: '380 gsm',
                'Internal Cut': 'No',
                Lamination: 'None',
                'Paper Type': 'SBS Paperboard',
                'Printing Layout': 'Front side only printing',
                'Printing White': 'None',
                'Production Time': '72',
                Substrate: 'Technodesign 380gsm',
                'Sustainability Label': 'PAP 21',
            },
            version: 24,
        },
    // Friction Fit Sleeve (5x5x18cm)
    'https://surface.products.cimpress.io/v3/calculatedSurfaceSets?surfaceSetLink=https%3a%2f%2fsurface.products.cimpress.io%2fv4%2fsurfaceSets%2f6d13ee0f-623a-486d-a71c-fbb7fc34d664%2fversions%2f290&Die-Cut=fs_dp_l50xp50xa180&Spot%20Color%20Count%20Side%201=0&Special%20Finishing%20Type%20Side%201=None&Trim%20Width=21.93&Trim%20Height=29.7&Surface%20Bleed=0&Prepress%20Parameters%20URL=https%3a%2f%2fcimdoc-layouts.documents.cimpress.io%2fv1%2ftemplate%2fd7fe752c-5082-456e-9a13-8e4b7844bc9e~100%2fresolved&Prepress%20URL=https%3a%2f%2fprint.prepress.cimpress.io%2fv2%2fprint-prep%3fasynchronous%3dtrue&Printing%20Layout=Front+side+only+printing&_variantId=180d5666bb6592d8bb6af36c7e04c98eaee2fe25':
        {
            id: 'CIM-TQP7GEJ2',
            options: {
                AssembledDepth: '5',
                AssembledHeight: '18',
                AssembledWidth: '5',
                Coating: 'None',
                'Delivery Type': 'Normal',
                'Die-Cut': 'fs_dp_l50xp50xa180',
                'Feature-Closure': 'None',
                'Feature-Handle': 'None',
                'Feature-Lining Box': 'None',
                'Feature-Window': 'None',
                Lamination: 'None',
                Printing: 'Digital',
                'Printing Layout': 'Front side only printing',
                'Printing White': 'None',
                'Production Time': '72',
                Substrate: 'Technodesign 380gsm',
            },
            version: 26,
        },
    // Friction Fit Sleeve (10x10x15cm)
    'https://surface.products.cimpress.io/v3/calculatedSurfaceSets?surfaceSetLink=https%3a%2f%2fsurface.products.cimpress.io%2fv4%2fsurfaceSets%2f6d13ee0f-623a-486d-a71c-fbb7fc34d664%2fversions%2f290&Die-Cut=fs_dp_l100xp100xa150&Spot%20Color%20Count%20Side%201=0&Special%20Finishing%20Type%20Side%201=None&Trim%20Width=41.93&Trim%20Height=35.2&Surface%20Bleed=0&Prepress%20Parameters%20URL=https%3a%2f%2fcimdoc-layouts.documents.cimpress.io%2fv1%2ftemplate%2fd7fe752c-5082-456e-9a13-8e4b7844bc9e~100%2fresolved&Prepress%20URL=https%3a%2f%2fprint.prepress.cimpress.io%2fv2%2fprint-prep%3fasynchronous%3dtrue&Printing%20Layout=Front+side+only+printing&_variantId=0edbbcc429c6cbbdc2b53f9835381f77f74c3113':
        {
            id: 'CIM-TQP7GEJ2',
            options: {
                AssembledDepth: '10',
                AssembledHeight: '15',
                AssembledWidth: '10',
                Coating: 'None',
                'Delivery Type': 'Express',
                'Die-Cut': 'fs_dp_l100xp100xa150',
                Lamination: 'None',
                'Printing Layout': 'Front side only printing',
                'Printing White': 'None',
                'Production Time': '24',
                Substrate: 'Technodesign 380gsm',
            },
            version: 26,
        },
    // Carry Out Folder with Cold Foil (20x12x8cm)
    'https://surface.products.cimpress.io/v3/calculatedSurfaceSets?surfaceSetLink=https%3a%2f%2fsurface.products.cimpress.io%2fv4%2fsurfaceSets%2f4bc242e2-9fa3-4632-89fc-ba11dee22583%2fversions%2f106&Die-Cut=cof_l200xp120xa80&Spot%20Color%20Count%20Side%201=0&Special%20Finishing%20Type%20Side%201=Cold+Foil&Trim%20Width=55&Trim%20Height=49.05&Surface%20Bleed=0&Prepress%20Parameters%20URL=https%3a%2f%2fcimdoc-layouts.documents.cimpress.io%2fv1%2ftemplate%2f2ff25a76-3c55-4d57-8a2e-94b2f4dea4fd~110%2fresolved&Prepress%20URL=https%3a%2f%2fprint.prepress.cimpress.io%2fv2%2fprint-prep%3fasynchronous%3dtrue&Printing%20Layout=Front+and+back+side+different+printing&Internal%20Cut=No&_variantId=9b97df774388a6c45d309eb63f381a86023c02a9':
        {
            id: 'CIM-8YWJMDZQ',
            options: {
                AssembledDepth: '12',
                AssembledHeight: '8',
                AssembledWidth: '20',
                'Box Depth': '12 cm',
                'Box Width': '20 cm',
                Coating: 'Extra-thick varnish',
                DesignExperience: 'false',
                'Die-Cut': 'cof_l200xp120xa80',
                'Die-Cut type': 'cof_l200xp120xa80',
                ForcedReview: 'true',
                Grammage: '400 gsm',
                'Internal Cut': 'No',
                Lamination: 'Gloss outer only',
                'Paper Type': 'Classic Demimatt',
                'Printing Layout': 'Front and back side different printing',
                'Printing White': 'None',
                'Production Time': '24',
                Substrate: 'Classic Demimatt 400 gsm',
                'Sustainability Label': 'C/PAP 81',
            },
            version: 33,
        },
};
